import { ImpuestosPresentacionRequest } from "../models/Impuesto.model";

import axios from "axios";

export const consultarImpuestosPresentacion = async (precupon: number) => {
  return axios.get(`api/impuestos/ConsultarImpuestosPresentacion?precupon=${precupon}`)
}

export const actualizarImpuestosPresentacion = async (data: ImpuestosPresentacionRequest) => {
  return axios.post('api/impuestos/ActualizarImpuestosPresentacion', data)
}

export const borrarImpuestosPresentacion = async (preCupon: number) => {
  let data = {PreCupon: preCupon,};
  return axios.post('api/impuestos/BorrarImpuestosPresentacion',data)
}

export const crearImpuestosPresentacion = async (data: any) => {
  return axios.post('api/impuestos/CrearImpuestosPresentacion',data)
}

export const consultarImpuestosPredeterminados = async () => {
  return axios.get(`api/impuestos/ConsultarImpuestosPredeterminados?idAfiliado=0&idServicio=0`)
}


export const actualizarImpuestosPredeterminados = async (data: ImpuestosPresentacionRequest) => {
  return axios.post('api/impuestos/ActualizarImpuestosPredeterminados',data)
}

export const crearImpuestosPredeterminados = async (data: any) => {
  return axios.post('api/impuestos/CrearImpuestosPredeterminados',data)
}

export const consultarImpuestosPresentacionAutomaticaActualizados = async (preCupon:number) => {
  return axios.get(`api/impuestos/ConsultarImpuestosPresentacionAutomaticaActualizados?preCupon=${preCupon}`)
}

export const consultarImpuestosPresentacionAutomatica = async (preCupon:number) => {
  return axios.get(`api/impuestos/ConsultarImpuestosPresentacionAutomatica?preCupon=${preCupon}`)
}
